import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.json'
import tw from './tw.json'
import cn from './cn.json'

Vue.use(VueI18n);

export default new VueI18n({
    locale: localStorage.getItem('language') || 'cn', // 设置地区
    messages: {
        cn,
        tw,
        en
    }, // 设置地区信息
})